export const movementsEnum = {
  SUPPLY: 3,
  WITHDRAW: 2
}
